import React from 'react';
import './OnGoingProject.css';
const OnGoingProject = (props) => {


    return (
        <div data-aos="fade-in" data-aos-duration="3000" className='' >

            <div className="item" >
                <img src={(props?.projects.img)} alt="" />


            </div>
            <div className='onGoingProjectNameCard'>{(props?.projects.name)}</div>
        </div>
    );
};

export default OnGoingProject;